module.exports = __webpack_public_path__ + "static/media/ir.9dfd3f96.svg";